import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let GroupStatusComponentUpdate = {
    selector: "vcGroupStatusUpdate",
    templateUrl: "/angular/components/group/group-status-update.component.html",
    controller: class GroupStatusControllerUpdate {
        public status: string = "";
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        confirm(): void {
            this.dialog.hide(this.status);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("group")
    .component(GroupStatusComponentUpdate.selector, GroupStatusComponentUpdate);
